var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"sys-input-number",class:{ 'text-center': _vm.center },attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_setup.displayValue},on:{"input":_setup.onInput,"blur":_setup.onBlur,"focus":_setup.onFocus,"keypress":_setup.onKeypress}})
}
var staticRenderFns = []

export { render, staticRenderFns }